import { CoreModel } from '../core/core.model';
export class GroupModel extends CoreModel {

  label?: string;

  minSelected?: number;

  maxSelected?: number;

  allSelected?: boolean;
/**
 * @hidden
 * @param {?=} values
 */
constructor(values: Object = {}) {
    super(values);
    Object.assign(this, values);
  }
}

function GroupModel_tsickle_Closure_declarations() {
/** @type {?} */
GroupModel.prototype.label;
/** @type {?} */
GroupModel.prototype.minSelected;
/** @type {?} */
GroupModel.prototype.maxSelected;
/** @type {?} */
GroupModel.prototype.allSelected;
}

